const MuiFormLabel = {

};

export default MuiFormLabel;



// WEBPACK FOOTER //
// ./src/components/OverrideTheme/config/overrides/MuiFormLabel.js